import React, { useState } from 'react';
import Button from 'src/components/AnswerType/Button';
import { useLocale } from 'src/lib/hook';
import styles from './style.module.scss';

interface TextInputBoxProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleSubmit?: () => void;
  placeholder?: string;
  hideSubmitButton?: boolean;
}
const TextInputBox: React.FC<TextInputBoxProps> = ({
  value, onChange, handleSubmit, placeholder,
}) => {

  const [isFocused, setIsFocused] = useState(false);
  const { t } = useLocale();
  return (
    <div className={styles['text-input-box-container']}>
      <label className={`${styles['text-input-box-label']} ${isFocused || value ? styles.focused : ''}`}>
        {placeholder}
      </label>
      <textarea
        className={styles['text-input-box']}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      {handleSubmit && (
        <Button text={t('component.answerType.button.finishTheSurvey')} color={'primary'} onClick={handleSubmit} />
      )}
    </div>
  );

};

export default TextInputBox;
